<template>
  <div class="w-[200px] h-[387px] mx-auto my-[20px] relative">
    <div class="absolute top-[50%] translate-y-[-50%]">
      <img src="../assets/list_blank.png" alt="" class="w-full h-[200px]">
      <h2 style="color: #CCCCCC;font-size: 16px">No items found</h2>
    </div>
  </div>
</template>
<script>
  export default {
    name: "TableEmpty",
  }
</script>